export const FEATURE_FLAG_KEYS = [
  "adCenter",
  "ai",
  "userManagement",
  "circleManagement",
  "teamManagement",
  "familyManagement",
  "noticeBodyFormatting",
  "imageStudio",
  "planner",
  "nova",
] as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];

/** Flags that are off unless explicitly enabled via admin. */
export const OPT_IN_FEATURE_FLAG_KEYS = [
  "familyManagement",
  "noticeBodyFormatting",
  "imageStudio",
  "planner",
  "nova",
] as const;

export type OptInFeatureFlagKey = (typeof OPT_IN_FEATURE_FLAG_KEYS)[number];

export function isOptInFeatureFlagKey(
  key: FeatureFlagKey
): key is OptInFeatureFlagKey {
  return (OPT_IN_FEATURE_FLAG_KEYS as readonly string[]).includes(key);
}

export type FeatureFlagsRecord = Partial<Record<FeatureFlagKey, boolean>>;

export function getFeatureFlagsFromUser(
  user: unknown,
): FeatureFlagsRecord | undefined {
  if (!user || typeof user !== "object") {
    return undefined;
  }
  const raw = (user as { featureFlags?: unknown }).featureFlags;
  if (!raw || typeof raw !== "object") {
    return undefined;
  }
  return raw as FeatureFlagsRecord;
}

/** Missing flags default to enabled, except opt-in flags (e.g. familyManagement). */
export function isFeatureFlagEnabled(
  flags: FeatureFlagsRecord | undefined,
  key: FeatureFlagKey,
): boolean {
  if (isOptInFeatureFlagKey(key)) {
    return flags?.[key] === true;
  }
  return flags?.[key] ?? true;
}
